import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class DocumentsVerifyRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/documents-verify/documents-verify-routing.module.ts